/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "scan_planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface TrajectoryActionPlannerFocusState {
}

export enum TrajectoryActionPlannerFocusState_Enum {
  FOCUS_INVALID = 0,
  FOCUS_OFF = 1,
  FOCUS_WAITING = 2,
  FOCUS_LOCK = 3,
  FOCUS_TIMEOUT = 4,
  UNRECOGNIZED = -1,
}

export function trajectoryActionPlannerFocusState_EnumFromJSON(object: any): TrajectoryActionPlannerFocusState_Enum {
  switch (object) {
    case 0:
    case "FOCUS_INVALID":
      return TrajectoryActionPlannerFocusState_Enum.FOCUS_INVALID;
    case 1:
    case "FOCUS_OFF":
      return TrajectoryActionPlannerFocusState_Enum.FOCUS_OFF;
    case 2:
    case "FOCUS_WAITING":
      return TrajectoryActionPlannerFocusState_Enum.FOCUS_WAITING;
    case 3:
    case "FOCUS_LOCK":
      return TrajectoryActionPlannerFocusState_Enum.FOCUS_LOCK;
    case 4:
    case "FOCUS_TIMEOUT":
      return TrajectoryActionPlannerFocusState_Enum.FOCUS_TIMEOUT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TrajectoryActionPlannerFocusState_Enum.UNRECOGNIZED;
  }
}

export function trajectoryActionPlannerFocusState_EnumToJSON(object: TrajectoryActionPlannerFocusState_Enum): string {
  switch (object) {
    case TrajectoryActionPlannerFocusState_Enum.FOCUS_INVALID:
      return "FOCUS_INVALID";
    case TrajectoryActionPlannerFocusState_Enum.FOCUS_OFF:
      return "FOCUS_OFF";
    case TrajectoryActionPlannerFocusState_Enum.FOCUS_WAITING:
      return "FOCUS_WAITING";
    case TrajectoryActionPlannerFocusState_Enum.FOCUS_LOCK:
      return "FOCUS_LOCK";
    case TrajectoryActionPlannerFocusState_Enum.FOCUS_TIMEOUT:
      return "FOCUS_TIMEOUT";
    case TrajectoryActionPlannerFocusState_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseTrajectoryActionPlannerFocusState(): TrajectoryActionPlannerFocusState {
  return {};
}

export const TrajectoryActionPlannerFocusState = {
  encode(_: TrajectoryActionPlannerFocusState, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrajectoryActionPlannerFocusState {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrajectoryActionPlannerFocusState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TrajectoryActionPlannerFocusState {
    return {};
  },

  toJSON(_: TrajectoryActionPlannerFocusState): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TrajectoryActionPlannerFocusState>, I>>(
    base?: I,
  ): TrajectoryActionPlannerFocusState {
    return TrajectoryActionPlannerFocusState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrajectoryActionPlannerFocusState>, I>>(
    _: I,
  ): TrajectoryActionPlannerFocusState {
    const message = createBaseTrajectoryActionPlannerFocusState();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
